(function() {
    'use strict';

    console.log('SS Apps Fix: Script wird geladen...');

    class SSAppsProtector {
        constructor() {
            // Speicher für die gerenderten Geschwister-Elemente
            this.socialProofSibling = null;
            this.tabsSibling = null;
            this.tabStates = new Map();
            this.initialized = false;

            this.init();
        }

        init() {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.setup());
            } else {
                this.setup();
            }
        }

        setup() {
            console.log('SS Apps Fix: Initialisierung startet...');

            // Warte bis SS Apps gerendert haben
            setTimeout(() => {
                this.captureRenderedContent();
                this.attachEventListeners();
                this.startMutationObserver();
                this.initialized = true;
                console.log('SS Apps Fix: Initialisierung abgeschlossen!');
            }, 1500);
        }

        captureRenderedContent() {
            // Social Proof - finde das Geschwister-Element
            const socialProofMarker = document.getElementById('ss-social-proof');
            if (socialProofMarker) {
                // Das nächste Geschwister-Element sollte der gerenderte Content sein
                let sibling = socialProofMarker.nextElementSibling;

                // Suche nach dem richtigen Element (könnte auch mehrere Geschwister weiter sein)
                while (sibling) {
                    if (sibling.className && (
                        sibling.className.includes('section-template') ||
                        sibling.className.includes('proof-template'))) {
                        this.socialProofSibling = sibling.cloneNode(true);
                        console.log('SS Apps Fix: Social Proof Geschwister gespeichert', {
                            className: sibling.className,
                            contentLength: sibling.innerHTML.length
                        });
                        break;
                    }
                    sibling = sibling.nextElementSibling;
                }

                if (!this.socialProofSibling) {
                    console.warn('SS Apps Fix: Kein Social Proof Geschwister gefunden');
                }
            }

            // Tabs - finde das Geschwister-Element
            const tabsMarker = document.getElementById('ss-tabs-icon-insert-block');
            if (tabsMarker) {
                // Das nächste Geschwister-Element sollte der gerenderte Content sein
                let sibling = tabsMarker.nextElementSibling;

                // Suche nach dem richtigen Element
                while (sibling) {
                    if (sibling.className && sibling.className.includes('ss-tabs-icon-insert-block-template')) {
                        this.tabsSibling = sibling.cloneNode(true);
                        console.log('SS Apps Fix: Tabs Geschwister gespeichert', {
                            className: sibling.className,
                            contentLength: sibling.innerHTML.length
                        });

                        // Speichere Tab-Zustände
                        this.captureTabStates(sibling);
                        break;
                    }
                    sibling = sibling.nextElementSibling;
                }

                if (!this.tabsSibling) {
                    console.warn('SS Apps Fix: Kein Tabs Geschwister gefunden');
                }
            }
        }

        captureTabStates(tabsElement) {
            const answers = tabsElement.querySelectorAll('[class*="answer-template"]');
            answers.forEach((answer, index) => {
                const isOpen = answer.style.display !== 'none' &&
                    answer.style.height !== '0' &&
                    answer.style.height !== '0px';

                this.tabStates.set(index, {
                    isOpen: isOpen,
                    display: answer.style.display,
                    height: answer.style.height,
                    paddingTop: answer.style.paddingTop,
                    paddingBottom: answer.style.paddingBottom
                });

                if (isOpen) {
                    console.log(`SS Apps Fix: Tab ${index} ist offen`);
                }
            });
        }

        restoreContent() {
            console.log('SS Apps Fix: Stelle Content wieder her...');

            // Social Proof wiederherstellen
            if (this.socialProofSibling) {
                const marker = document.getElementById('ss-social-proof');
                if (marker) {
                    // Prüfe ob das Geschwister-Element fehlt oder leer ist
                    let currentSibling = marker.nextElementSibling;
                    let foundValidSibling = false;

                    while (currentSibling && !foundValidSibling) {
                        if (currentSibling.className && (
                            currentSibling.className.includes('section-template') ||
                            currentSibling.className.includes('proof-template'))) {
                            // Prüfe ob es Inhalt hat
                            if (currentSibling.innerHTML.trim().length > 50) {
                                foundValidSibling = true;
                            } else {
                                // Element existiert aber ist leer - entferne es
                                currentSibling.remove();
                            }
                            break;
                        }
                        currentSibling = currentSibling.nextElementSibling;
                    }

                    if (!foundValidSibling) {
                        console.log('SS Apps Fix: Social Proof Geschwister fehlt oder ist leer, stelle wieder her...');
                        const restored = this.socialProofSibling.cloneNode(true);
                        marker.insertAdjacentElement('afterend', restored);
                    }
                }
            }

            // Tabs wiederherstellen
            if (this.tabsSibling) {
                const marker = document.getElementById('ss-tabs-icon-insert-block');
                if (marker) {
                    // Prüfe ob das Geschwister-Element fehlt oder leer ist
                    let currentSibling = marker.nextElementSibling;
                    let foundValidSibling = false;

                    while (currentSibling && !foundValidSibling) {
                        if (currentSibling.className &&
                            currentSibling.className.includes('ss-tabs-icon-insert-block-template')) {
                            // Prüfe ob es Inhalt hat
                            if (currentSibling.innerHTML.trim().length > 50) {
                                foundValidSibling = true;
                            } else {
                                // Element existiert aber ist leer - entferne es
                                currentSibling.remove();
                            }
                            break;
                        }
                        currentSibling = currentSibling.nextElementSibling;
                    }

                    if (!foundValidSibling) {
                        console.log('SS Apps Fix: Tabs Geschwister fehlt oder ist leer, stelle wieder her...');
                        const restored = this.tabsSibling.cloneNode(true);
                        marker.insertAdjacentElement('afterend', restored);

                        // Re-initialisiere Tab-Funktionalität nach kurzer Pause
                        setTimeout(() => {
                            this.reinitializeTabs(restored);
                            this.restoreTabStates(restored);
                        }, 100);
                    }
                }
            }
        }

        reinitializeTabs(tabsElement) {
            console.log('SS Apps Fix: Re-initialisiere Tab-Funktionalität...');

            const buttons = tabsElement.querySelectorAll('[class*="button-template"]');

            buttons.forEach((button, index) => {
                // Entferne alte Event Listener
                const newButton = button.cloneNode(true);
                button.parentNode.replaceChild(newButton, button);

                // Füge neuen Click-Handler hinzu
                newButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const answer = newButton.nextElementSibling;
                    if (!answer || !answer.className.includes('answer-template')) return;

                    this.toggleTab(answer, newButton, index);
                });
            });
        }

        toggleTab(answer, button, index) {
            const isCurrentlyOpen = answer.style.display !== 'none' &&
                answer.style.height !== '0' &&
                answer.style.height !== '0px';

            if (isCurrentlyOpen) {
                this.animateClose(answer, button);
                this.tabStates.set(index, { isOpen: false });
            } else {
                this.animateOpen(answer, button);
                this.tabStates.set(index, { isOpen: true });
            }
        }

        animateOpen(answer, button) {
            // Finde die Höhe aus dem Kalkulations-Element
            const parent = answer.closest('[class*="grid-template"]');
            if (parent) {
                const calcElements = parent.querySelectorAll('[class*="faq-answer-height-cal"]');
                calcElements.forEach(calc => {
                    const calcAnswer = calc.querySelector('[class*="answer-template"]');
                    if (calcAnswer && calcAnswer.innerHTML === answer.innerHTML) {
                        answer.style.height = calcAnswer.offsetHeight + 'px';
                    }
                });
            }

            // Öffne mit Animation
            answer.style.display = 'block';
            answer.style.height = answer.style.height || 'auto';
            answer.style.paddingTop = '15px';
            answer.style.paddingBottom = '15px';
            answer.style.overflow = 'hidden';
            answer.style.transition = 'all 0.3s ease';

            // Rotiere Pfeil
            const arrow = button.querySelector('svg[class*="icon-template"]');
            if (arrow) {
                arrow.style.setProperty('--rotate', '180deg');
            }

            setTimeout(() => {
                answer.style.height = 'auto';
                answer.style.overflow = '';
            }, 300);
        }

        animateClose(answer, button) {
            // Setze feste Höhe für Animation
            answer.style.height = answer.offsetHeight + 'px';
            answer.style.overflow = 'hidden';

            // Force reflow
            answer.offsetHeight;

            // Animiere Schließung
            answer.style.transition = 'all 0.3s ease';
            answer.style.height = '0px';
            answer.style.paddingTop = '0';
            answer.style.paddingBottom = '0';

            // Rotiere Pfeil zurück
            const arrow = button.querySelector('svg[class*="icon-template"]');
            if (arrow) {
                arrow.style.setProperty('--rotate', '0deg');
            }

            setTimeout(() => {
                answer.style.display = 'none';
            }, 300);
        }

        restoreTabStates(tabsElement) {
            const answers = tabsElement.querySelectorAll('[class*="answer-template"]');
            const buttons = tabsElement.querySelectorAll('[class*="button-template"]');

            this.tabStates.forEach((state, index) => {
                const answer = answers[index];
                const button = buttons[index];

                if (answer && button && state.isOpen) {
                    console.log(`SS Apps Fix: Stelle Tab ${index} wieder her (war offen)`);

                    // Öffne ohne Animation
                    answer.style.display = 'block';
                    answer.style.height = 'auto';
                    answer.style.paddingTop = '15px';
                    answer.style.paddingBottom = '15px';

                    // Setze Pfeil
                    const arrow = button.querySelector('svg[class*="icon-template"]');
                    if (arrow) {
                        arrow.style.setProperty('--rotate', '180deg');
                    }
                }
            });
        }

        attachEventListeners() {
            console.log('SS Apps Fix: Registriere Event Listener...');

            // Shopify Variant Events
            const events = [
                'variant:change',
                'variant:switch',
                'product:variant:change',
                'product-form:change'
            ];

            events.forEach(eventName => {
                document.addEventListener(eventName, (e) => {
                    console.log(`SS Apps Fix: Event "${eventName}" erkannt`);
                    this.handleVariantChange();
                });
            });

            // Variant Selektoren
            const variantInputs = document.querySelectorAll(
                '[name="id"], ' +
                '.single-option-selector, ' +
                'variant-radios input, ' +
                'variant-selects select, ' +
                '.product-form__input input[type="radio"], ' +
                '.product-form__input select, ' +
                '.variant-input'
            );

            variantInputs.forEach(input => {
                input.addEventListener('change', () => {
                    console.log('SS Apps Fix: Variant Input geändert');
                    this.handleVariantChange();
                });
            });

            // Überwache URL-Änderungen
            let lastUrl = location.href;
            new MutationObserver(() => {
                const url = location.href;
                if (url !== lastUrl) {
                    lastUrl = url;
                    if (url.includes('variant=')) {
                        console.log('SS Apps Fix: URL-Änderung mit Variante erkannt');
                        this.handleVariantChange();
                    }
                }
            }).observe(document, { subtree: true, childList: true });
        }

        startMutationObserver() {
            console.log('SS Apps Fix: Starte Mutation Observer...');

            // Beobachte den Bereich um die Marker-Elemente
            const productInfo = document.querySelector('.product-info, .product__info, .product-single, .product-template');

            if (!productInfo) {
                console.warn('SS Apps Fix: Kein Produkt-Container für Observer gefunden');
                return;
            }

            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.type === 'childList') {
                        // Prüfe entfernte Nodes
                        for (const node of mutation.removedNodes) {
                            if (node.nodeType === 1 && node.className) {
                                const isImportant =
                                    node.className.includes('section-template') ||
                                    node.className.includes('proof-template') ||
                                    node.className.includes('ss-tabs-icon-insert-block-template');

                                if (isImportant) {
                                    console.log('SS Apps Fix: Wichtiges Element wurde entfernt!', node.className);
                                    this.handleContentRemoval();
                                    return;
                                }
                            }
                        }
                    }
                }
            });

            observer.observe(productInfo, {
                childList: true,
                subtree: true
            });
        }

        handleVariantChange() {
            if (!this.initialized) return;

            clearTimeout(this.variantChangeTimeout);
            this.variantChangeTimeout = setTimeout(() => {
                console.log('SS Apps Fix: Verarbeite Variantenwechsel...');
                this.restoreContent();
            }, 300);
        }

        handleContentRemoval() {
            if (!this.initialized) return;

            clearTimeout(this.removalTimeout);
            this.removalTimeout = setTimeout(() => {
                console.log('SS Apps Fix: Content wurde entfernt, stelle sofort wieder her!');
                this.restoreContent();
            }, 50);
        }
    }

    // Initialisiere
    window.SSAppsProtector = new SSAppsProtector();

    // Fallback-Prüfung alle 2 Sekunden
    setInterval(() => {
        if (!window.SSAppsProtector || !window.SSAppsProtector.initialized) return;

        let needsRestore = false;

        // Prüfe Social Proof
        const socialProofMarker = document.getElementById('ss-social-proof');
        if (socialProofMarker && window.SSAppsProtector.socialProofSibling) {
            let found = false;
            let sibling = socialProofMarker.nextElementSibling;

            while (sibling) {
                if (sibling.className && (
                    sibling.className.includes('section-template') ||
                    sibling.className.includes('proof-template'))) {
                    if (sibling.innerHTML.trim().length > 50) {
                        found = true;
                    }
                    break;
                }
                sibling = sibling.nextElementSibling;
            }

            if (!found) {
                console.log('SS Apps Fix: Fallback - Social Proof fehlt');
                needsRestore = true;
            }
        }

        // Prüfe Tabs
        const tabsMarker = document.getElementById('ss-tabs-icon-insert-block');
        if (tabsMarker && window.SSAppsProtector.tabsSibling) {
            let found = false;
            let sibling = tabsMarker.nextElementSibling;

            while (sibling) {
                if (sibling.className &&
                    sibling.className.includes('ss-tabs-icon-insert-block-template')) {
                    if (sibling.innerHTML.trim().length > 50) {
                        found = true;
                    }
                    break;
                }
                sibling = sibling.nextElementSibling;
            }

            if (!found) {
                console.log('SS Apps Fix: Fallback - Tabs fehlen');
                needsRestore = true;
            }
        }

        if (needsRestore) {
            window.SSAppsProtector.restoreContent();
        }
    }, 2000);

    console.log('SS Apps Fix: Script vollständig geladen!');
})();